import CacheManager from '../cacheManager';

let _modelTLA; // eslint-disable-line no-unused-vars

export default class ISharedModelService {
  constructor(modelTLA) {
    _modelTLA = modelTLA;
    this.cache = CacheManager.instance();
    console.log('app.services.ISharedModelService created');
  }

  /**
   * Takes a collection of objects and sorts them by their name property (required field)
   * @param {Array<Object>} collection
   * @returns {Array<Object>}
   */
  sortByName(collection) {
    return this.sort(collection, 'name');
  }

  /**
   * Takes a collection of objects and sorts them by given property
   * @param {Array<Object>} collection
   * @returns {Array<Object>}
   */
  sort(collection, key) {
    return collection.sort((a, b) => {
      const aValue = _getSortableValue(a, key);
      const bValue = _getSortableValue(b, key);
      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
  }

  /**
   *
   * @param {string} str - the string to be hashed
   * @return {number}
   */
  getHash(str) {
    if (!str) return -1;
    let hash = 0;
    let i;
    let chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) { // eslint-disable-line no-plusplus
      chr = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr; // eslint-disable-line no-bitwise
      // Convert to 32bit integer
      hash |= 0; // eslint-disable-line no-bitwise
    }
    return Math.abs(hash);
  }
}

function _getSortableValue(obj, key) {
  return typeof obj[key] === 'string' ? obj[key].toLowerCase() : obj[key];
}
